import {HostMaps} from '../utils/host/AutoHost'
// hiya-version域名
export const HiyaVerHost = HostMaps.auto.version
// hiya-activity域名
export const HiyaActHost = HostMaps.auto.activity
// 支付页面
export const PaymentPage = `${HiyaVerHost}/habiWalletTab`
// 游戏中心 ----- 有积分商城
export const GameCenterUrl = {
  production: `${HostMaps.prod.activity}/ToyBricksView/1544`,
  test: 'http://me-hiya-web-activity-test.ixiaochuan.cn/ToyBricksView/1442',
  development:
    'http://me-hiya-web-activity-test.ixiaochuan.cn/ToyBricksView/1442',
}[ENV]
// 外网域名
export const ApiHost = HostMaps.auto.api
// hiya-web域名
export const HiyaWebHost = HostMaps.auto.web
// 老老老库域名
export const OldHiyaH5Host = HostMaps.auto.websit
export const getPic = (id) => {
  return `${HostMaps.auto.img01}/img/png/id/${id}`
}
